export default __webpack_public_path__ + "static/media/partner-polkaex.b2b7e2ac.svg";